import { APIClient } from "./axiosClient";

export class BrandApi {
  static fetchAllBrands() {
    return APIClient("/brand/getAllBrands");
  }
} 